__turbopack_context__.v({
  "__browse-button": "navbar-module-scss-module__mVFYuq____browse-button",
  "__dropdown": "navbar-module-scss-module__mVFYuq____dropdown",
  "__dropdown-container": "navbar-module-scss-module__mVFYuq____dropdown-container",
  "__dropdown-item": "navbar-module-scss-module__mVFYuq____dropdown-item",
  "__dropdown-item-button": "navbar-module-scss-module__mVFYuq____dropdown-item-button",
  "__dropdown-item-link": "navbar-module-scss-module__mVFYuq____dropdown-item-link",
  "__group-list": "navbar-module-scss-module__mVFYuq____group-list",
  "__left-side-button": "navbar-module-scss-module__mVFYuq____left-side-button",
  "__question-list": "navbar-module-scss-module__mVFYuq____question-list",
  "__right-side-button": "navbar-module-scss-module__mVFYuq____right-side-button",
  "__sidebar": "navbar-module-scss-module__mVFYuq____sidebar",
  "navbar": "navbar-module-scss-module__mVFYuq__navbar",
});
